const A = 'A'
const B = 'B'
const C = 'C'

export const METER_INPUT = [A, B, C]
